module.exports = __webpack_public_path__ + "static/media/mem8YaGs126MiZpBA-UFVp0bbck.7aed216c.woff2";